import { Flex, FormLabel, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { GreenButton } from '../../../../../components/Buttons/GreenButton'
import { GreyButton } from '../../../../../components/Buttons/GreyButton'
import { MetaButton } from '../../../../../components/Buttons/MetaButton'
import { InputFormControl } from '../../../../../components/InputFormControl'
import { ModalBase } from '../../../../../components/ModalBase'
import { TagContainer } from '../../../../../components/TagContainer'
import { useFormulario } from '../../../../../contexts/FormularioContext'
import { iModalPadrao, iEnunciado, iPostCompetencia } from '../../../../../interfaces'
import { appApi } from '../../../../../services/appApi'
import { ModalBody } from './styles'

interface IModal extends iModalPadrao {
  CompetenciaId?: string
}

export const ModalCriarCompetencia: React.FC<IModal> = ({ OnCloseModal, isOpen, CompetenciaId }) => {
  if (!isOpen) {
    return null
  }

  const toast = useToast()
  const { ObterCompetencias, AtualizarCompetencia, SelectCompetencia, ctxCompetencias } = useFormulario()

  const [NomeCompet, setNomeCompet] = useState('')
  const [Questoes, setQuestoes] = useState<iEnunciado[]>([{ enunciado: '' }])

  const [Imagens, setImagens] = useState<string[]>([])
  const [imgSel, setimgSel] = useState(0)
  const [TagsSel, setTagsSel] = useState<string[]>([])

  function getImgs(): void {
    appApi.get('Assets').then(response => {
      setImagens((response.data as string[]).filter(e => e.includes('svg')))
    }).catch(err => console.log(err))
  }

  function UpdateQuetaoArray(index: number, Texto: string): void {
    const array = [...Questoes]
    array[index].enunciado = Texto
    setQuestoes(array)
  }

  function GetCompetenciaById(): void {
    const competencia = ctxCompetencias.find(e => e.id === CompetenciaId)
    if (competencia) {
      setNomeCompet(competencia.nome)
      setimgSel(Imagens.indexOf(competencia.icone))
      if (competencia.tags !== null && competencia.tags !== undefined) {
        setTagsSel(competencia.tags)
      }
    }
  }

  function addTag(tag: string): void {
    setTagsSel(oldArray => [...oldArray, tag])
  }

  function removeTag(id: string): void {
    setTagsSel(TagsSel.filter(r => r !== id))
  }

  function CriarCompetencia(form: iPostCompetencia): void {
    appApi.post('Competencia', form)
      .then(res => {
        ObterCompetencias()
        SelectCompetencia(res.data)
        toast({
          title: 'Competência criada e selecionada com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right'
        })
        OnCloseModal()
      })
      .catch(() => {
        toast({
          title: 'Há campos sem preenchimento',
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 3000
        })
      })
  }

  useEffect(() => {
    getImgs()
  }, [])

  useEffect(() => {
    if (CompetenciaId !== undefined) {
      GetCompetenciaById()
    }
  }, [Imagens])

  return (
    <ModalBase
      Titulo='Criar competência'
      isOpen={isOpen}
      onClose={OnCloseModal}
      Width='65rem'
    >
      <ModalBody>
        <h3 style={{ color: 'var(--a3)', marginBottom: '.5rem' }}>Selecione um ícone</h3>
        <section>
          {
            Imagens.map((e: string, i) => {
              if (i === imgSel) {
                return (
                  <img style={{ border: '0.25rem solid var(--v1)' }} key={i} src={e} />
                )
              } else {
                return (
                  <img onClick={() => setimgSel(i)} key={i} src={e} />
                )
              }
            })
          }
        </section>

        <Flex margin={'1rem 0'}>
          <InputFormControl
            value={NomeCompet}
            placeholder='Digite o nome da competência'
            label='Nome da competência'
            onChange={(e) => setNomeCompet(e.target.value)}
          />
        </Flex>

        <TagContainer
          Selecionadas={TagsSel}
          addTag={addTag}
          removeTag={removeTag}
          isGrey
          tipo={0}
        />
        {
          (CompetenciaId === undefined) && (
            <>
              <Flex marginTop={'1rem'} flexDir={'column'}>
                <FormLabel margin={0} color={'var(--Gray1)'} fontSize={'xl'}>Questões</FormLabel>
                <Flex margin={'1rem 0'} flexDir={'column'} gap={'1rem'}>
                  {
                    Questoes.map((e: iEnunciado, i) => {
                      return (
                        <InputFormControl
                          key={i}
                          placeholder='Digite a questão'
                          value={e.enunciado}
                          onChange={(e) => { UpdateQuetaoArray(i, e.target.value) }}
                        />
                      )
                    })
                  }
                </Flex>
              </Flex>
              <Flex>
                <MetaButton onClick={() => setQuestoes(oldArray => [...oldArray, { enunciado: '' }])} bg='a1' size='md'>Adicionar questão</MetaButton>
              </Flex>
            </>
          )

        }
      </ModalBody>
      <Flex justifyContent={'end'} padding={'1rem'} gap={'1rem'}>
        <GreyButton Size='md' isNav={false} onClick={() => OnCloseModal()}>Fechar</GreyButton>
        {
          CompetenciaId === undefined
            ? <GreenButton Size='md' isNav={false} OnClick={() => {
              CriarCompetencia({
                nome: NomeCompet,
                tags: TagsSel,
                icone: Imagens[imgSel],
                questoes: Questoes
              })
            }}>Criar competência</GreenButton>
            : <GreenButton Size='md' isNav={false} OnClick={() => {
              AtualizarCompetencia(CompetenciaId, {
                nome: NomeCompet,
                icone: Imagens[imgSel],
                tags: TagsSel
              }); OnCloseModal()
            }}>Atualizar competência</GreenButton>
        }
      </Flex>
    </ModalBase>
  )
}
